import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button'
// Shared components
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import ReactAudioPlayer from 'react-audio-player';

import { api_host } from '../../common/globals/constants';
import { AtCircularProgress } from '../../components/AtCircularProgress';
import { Box, DialogContent, DialogTitle } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
class Audio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            range: {},
            dateRange: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',                    
                },
            },
            audio: this.props.data.setAudio,
            currentObjectiveId: this.props.data.currentObjectiveId,
            isLoading: true,
            isEmpty: false,
            audioPatternName: this.props.data.setAudio['patron']
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {currentObjectiveId, audio } = this.state
        let token = sessionStorage.getItem('key')
        
        fetch (api_host+`/reporte/general/objetivos/${currentObjectiveId}/audios_ivr/audio/?token=${token}&hash=${audio['hash_md5']}`)   
            //.then( response => response.body.getReader())     
            .then( response => response.json())
            .then( myJson =>  {                   
                                try {
                                    this.processData(myJson)   
                                            
                                } catch (error) {
                                    this.setState({
                                        dataError: true,
                                        data: null,
                                        isLoading: false
                                    });
                                }
                            });
        
    }
    processData = (externalData) => {
        /*externalData
        .read()
        .then((result) => {
            var blob = new Blob([result.value], { type: 'audio/wav' });
            var audioUrl = URL.createObjectURL(blob)
            //var audio = new Audio(audioUrl);
            //var audio = new Audio();
            //audio.src = audioUrl;
            //window.audio.play();
            var isEmpty = false
            if (blob.size == 0){
                isEmpty = true
            }
            this.setState({audioUrl: audioUrl, isLoading: false, isEmpty: isEmpty});
        });*/
        
        const byteCharacters = atob(externalData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'audio/wav' });
        var audioUrl = URL.createObjectURL(blob)
        //var audio = new Audio(audioUrl);
        //var audio = new Audio();
        //audio.src = audioUrl;
        //window.audio.play();
        var isEmpty = false
        if (blob.size == 0){
            isEmpty = true
        }
        this.setState({audioUrl: audioUrl, isLoading: false, isEmpty: isEmpty});
        
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    render() {
        const {isLoading, audio, audioUrl, isEmpty, audioPatternName} = this.state
        var patternName = ''
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (audioPatternName) {
            patternName = '_'+audioPatternName
        }
        if (!isLoading)  {
            return  <>
                        <DialogTitle className='at-blue-background'>
                            <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                                <Typography variant="h4" style={{color: 'white'}}>
                                    {t('audio.modal.title')}
                                </Typography>
                                {isEmpty ?
                                    null
                                :
                                    <Button href={audioUrl}
                                        target="_blank"
                                        download={audio['paso_nombre']+patternName}>
                                        <CloudDownloadIcon style={{color:"white"}}  />
                                    </Button>
                                }
                                <IconButton 
                                    key="close" 
                                    aria-label="close" 
                                    style={{color:"white"}}
                                    onClick={this.handleClose}>
                                        <CloseIcon/>
                                </IconButton>
                            </Box>
                            <Box>
                                <Typography variant='h6' style={{color: 'white'}}>{audio['paso_nombre']+patternName}</Typography>
                            </Box>
                        </DialogTitle>
                        <DialogContent style={{
                            backgroundColor: 'white',
                            textAlign: 'center',
                            position: 'relative',
                            overflow: 'auto'
                        }}>
                            {isEmpty ?
                                <Typography                                        
                                    variant="h3">                                     
                                    {t('audio.alert.error.no-audio')}
                                </Typography> 
                            :<ReactAudioPlayer
                                src={audioUrl}
                                controls
                                controlsList="nodownload"
                            />}    
                            
                        </DialogContent>
                    </>            
        } else {
            return <AtCircularProgress />      
        }
    }
}
export default compose(withTranslation())(Audio);